import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-0 left-0 right-0 z-50 p-4 sm:p-6"
          data-testid="cookie-consent"
        >
          <div className="max-w-3xl mx-auto bg-[#071E45] border border-white/10 rounded-2xl p-6 sm:p-7 shadow-2xl">
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-5">
              <div className="flex-1">
                <p className="text-white/80 text-sm leading-relaxed">
                  Bu web sitesi, deneyiminizi iyileştirmek için çerezler kullanmaktadır. Sitemizi kullanmaya devam ederek{' '}
                  <Link to="/kvkk" className="text-[#FF6B2C] hover:underline font-medium">KVKK Aydınlatma Metni</Link>
                  'ni kabul etmiş sayılırsınız.
                </p>
              </div>
              <Button
                onClick={accept}
                className="bg-[#FF6B2C] hover:bg-[#E55A1F] text-white rounded-full font-semibold px-7 py-2.5 text-sm whitespace-nowrap shadow-lg shadow-orange-500/20"
                data-testid="cookie-accept-button"
              >
                Kabul et
              </Button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;
